export const VerificationRequestStatusLabels = {
    Employee_To_Respond: 'Employee to Respond',
    Report_Created: 'Report Created',
    Declined_By_Employee: 'Declined by Employee',
    Reviewed_By_Verifier: 'Reviewed by Verifier',
    Verifier_To_Respond: 'Verifier to Respond',
    Declined_By_Verifier: 'Declined by Verifier',
};
// Api verification requests have no lifecycle. They are informational records of data already
// shared with the integration's verifier. This is the only status they ever display.
export const API_VERIFICATION_REQUEST_STATUS_LABEL = 'Data Shared';
export const DataDisputeItemStatusLabels = {
    In_Progress: 'In Progress (Data dispute in progress)',
    Resolved: 'Resolved (Data dispute resolved)',
};
export const INITIAL_DATA_CHUNK_SIZE = 10;
//# sourceMappingURL=inboxItem.js.map